module.exports = __webpack_public_path__ + "img/page-expiry.d34eea49.svg";